import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IQuizQuestion } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class QuizQuestionService extends BaseService<IQuizQuestion> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'quizQuestion');
  }
}

export { IQuizQuestion } from '../shared/api';
